<script>
import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'InvoiceSettlementForm'
})
class InvoiceSettlementForm extends Vue {}

export default InvoiceSettlementForm
</script>

<template>
  <div className="inner-component-container">
    <slot name="header"></slot>
    <hr>
    <slot name="content"></slot>
  </div>
</template>
